import React, { FunctionComponent } from "react"
import "./PTOPlanMaintenanceWarnLostChanges.css"
import { Button, Modal } from "react-bootstrap"

interface Props {
    handleDiscard: Function
}

const PTOPlanMaintenanceWarnLostChanges: FunctionComponent<Props> = (props) => {

    const { handleDiscard } = props

    return (
        <div className="PTOPlanMaintenanceWarnLostChanges">
            <Modal
                id="b21b212e0407581eb9ae69415e6c1"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
            >
                <Modal.Header>
                    <div className="PTOPlanMaintenanceWarnLostChangesModalHeader">
                        <p>Switch to Salary?</p>
                    </div>
                </Modal.Header>
                <Modal.Header>
                    <div className="PTOPlanMaintenanceWarnLostChangesModalBody">
                        <p className="c7a466aea48683e37977a763f1c1">Switching from hourly to salary will clear:</p>
                        <p className="aac85b7ddd453396ac430b3d50f6">*Hourly Calculation Method</p>
                        <p>*Hourly Accrual amounts</p>
                    </div>
                </Modal.Header>
                <Modal.Footer>
                    <div className="PTOPlanMaintenanceWarnLostChangesModalFooter">
                        <Button variant="secondary" onClick={() => handleDiscard(false)}>Cancel</Button>
                        <Button variant="danger" onClick={() => handleDiscard(true)}>Switch</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default PTOPlanMaintenanceWarnLostChanges